import web3Singletone from '../configWeb3';
import { abi, networks } from '../../build_sidechain/contracts/Products.json';

import { getEventOutputAbi, getFunctionOutputAbi, paramParser } from './contractHandle';

class Products {
  constructor(privateKeyBase64) {
    const web3 = web3Singletone.getWeb3(privateKeyBase64);
    const publicAddress = web3Singletone.getPublicAddress(privateKeyBase64);
    this.contract = new web3.eth.Contract(abi, networks[web3Singletone.getNetwork()].address, {
      from: publicAddress
    });
  }

  /**
   * add product to product's array
   * @param {*} category      : uint
   * @param {*} image         : string
   * @param {*} name          : string
   * @param {*} price         : uint
   * @param {*} quantity      : uint
   * @param {*} description   : string
   * @param {*} detail        : string
   */
  async addProduct(subCategory, category, image, name, price, quantity, description, detail) {
    const addPro = await this.contract.methods
      .addProduct(subCategory, category, image, name, price, quantity, description, detail)
      .send();

    const eventOutputAbi = await getEventOutputAbi('LogAddProduct', abi);

    const addProductEvent = {};
    if (addPro && addPro.events && addPro.events.LogAddProduct) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, addPro.events.LogAddProduct.returnValues);
        addProductEvent[parserValue.key] = parserValue.value;
        return true;
      });
    }

    return addProductEvent;
  }

  async addProductProperty(productId, quantity, attribute) {
    const addProperty = await this.contract.methods.AddPrdProperty(productId, 0, quantity, attribute, 0).send();
    const eventOutputAbi = await getEventOutputAbi('LogUpdatePrdProperty', abi);
    const addPropertyEvent = {};
    if (addProperty && addProperty.events && addProperty.events.LogUpdatePrdProperty) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, addProperty.events.LogUpdatePrdProperty.returnValues);
        addPropertyEvent[parserValue.key] = parserValue.value;
        return true;
      });
    }
    return addPropertyEvent;
  }

  async updateProductProperty(pId, pretId, quantity, attribute) {
    const updateProperty = await this.contract.methods.AddPrdProperty(pId, pretId, quantity, attribute, 1).send();
    const eventOutputAbi = await getEventOutputAbi('LogUpdatePrdProperty', abi);
    const updatePropertyEvent = {};
    if (updateProperty && updateProperty.events && updateProperty.events.LogUpdatePrdProperty) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, updateProperty.events.LogUpdatePrdProperty.returnValues);
        updatePropertyEvent[parserValue.key] = parserValue.value;
        return true;
      });
    }
    return updatePropertyEvent;
  }

  async deletePropOfProduct(productId, propId) {
    return await this.contract.methods.deletePropOfProduct(productId, propId).send();
  }

  async getListPropertyIds(productId) {
    return await this.contract.methods.getListPropertyIds(productId).call();
  }

  async getProductPropertyById(pretId) {
    const rawResult = await this.contract.methods.getProductPropertyById(pretId).call();
    const functionOutputAbi = await getFunctionOutputAbi('getProductPropertyById', abi);
    const endResult = {};
    functionOutputAbi.map(eachParam => {
      const parserValue = paramParser(eachParam, rawResult);
      return (endResult[parserValue.key] = parserValue.value);
    });
    return endResult;
  }

  /**
   *
   * @param {*} category      : uint
   * @param {*} image         : string
   * @param {*} name          : string
   * @param {*} shopName      : string
   * @param {*} price         : uint
   * @param {*} quantity      : uint
   * @param {*} description   : string
   * @param {*} detail        : string
   */
  async updateProduct(id, subCategory, category, image, shopName, name, price, quantity, description, detail) {
    const updatePro = await this.contract.methods
      .updateProduct(id, subCategory, category, image, shopName, name, price, quantity, description, detail)
      .send();

    const eventOutputAbi = await getEventOutputAbi('UpdateProduct', abi);

    const updateProductEvent = {};
    if (updatePro && updatePro.events && updatePro.events.UpdateProduct) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, updatePro.events.UpdateProduct.returnValues);
        updateProductEvent[parserValue.key] = parserValue.value;
        return true;
      });
    }

    return updateProductEvent;
  }

  /**
   *
   * @param {*} catId id of category
   * @param {*} range length of array will be get
   * @param {*} from from(id)
   */
  async getListProductsByCatDesc(catId, from, range) {
    const rawResult = await this.contract.methods.getListProductsByCatDesc(catId, from, range).call();
    const functionOutputAbi = await getFunctionOutputAbi('getListProductsByCatDesc', abi);
    const functionComponents = functionOutputAbi[0].components;

    return rawResult.map(result => {
      const product = {};
      functionComponents.map(eachParam => {
        const parserValue = paramParser(eachParam, result);
        return (product[parserValue.key] = parserValue.value);
      });
      return product;
    });
  }

  /**
   *
   * @param {*} from  starting position to get from(id)
   * @param {*} range the number of products need to get
   */
  async getListProductDesc(from, range) {
    const rawResult = await this.contract.methods.getListProductDesc(from, range).call();

    const functionOutputAbi = await getFunctionOutputAbi('getListProductDesc', abi);
    const functionComponents = functionOutputAbi[0].components;

    return rawResult.map(result => {
      const product = {};
      functionComponents.map(eachParam => {
        const parserValue = paramParser(eachParam, result);
        return (product[parserValue.key] = parserValue.value);
      });
      return product;
    });
  }

  /**
   * get all product info by id
   * example return:
   *  { categoryId: 1,
   *    inxInCat: 1,
   *    id: 1,
   *    image: '["https://www.jpg", "https://www..jpg"]',
   *    shopName: 'Book HN',
   *    name: 'カラーラ【送料無料】',
   *    price: 524600000000000000,
   *    review: 0,
   *    owner: '0x0408FB9198C9ba408ff310788920C2Fb0c238882',
   *    status: 1,
   *    quantity: 50,
   *    description: '従来品と比べてサイズも重さもコンパクト設計でご家庭のキッチンにぴったり。',
   *    detail: 'ヘルシー！おいしい！油なっしー！健康フライヤー「カラーラ」。',
   *    createdAt: 1543913099,
   *    updatedAt: 1543913099 }
   * @param {*} id id of product
   * @return Object of Product
   */
  async getAllInfoById(id) {
    const result = await this.contract.methods.getAllInfoById(id).call();

    const functionOutputAbi = await getFunctionOutputAbi('getAllInfoById', abi);

    if (!functionOutputAbi || functionOutputAbi.length < 2) {
      throw new Error('Failed to read output ABI of contract and parse required components');
    }

    const product = {};

    for (let i = 0; i < functionOutputAbi.length; i++) {
      // Extract each of the component and parse it with the result to get key-value of Product Object
      const functionComponents = functionOutputAbi[i].components;
      // eslint-disable-next-line
      await functionComponents.map(eachParam => {
        const parserValue = paramParser(eachParam, result[i]);
        product[parserValue.key] = parserValue.value;
        return true;
      });
    }

    return product;
  }

  /**
   * get product by id
   * @param {*} id id of product
   */
  async getProductById(id) {
    const result = await this.contract.methods.getProductById(id).call();

    const functionOutputAbi = await getFunctionOutputAbi('getProductById', abi);

    const product = {};
    const functionComponents = functionOutputAbi[0].components;

    await functionComponents.map(eachParam => {
      const parserValue = paramParser(eachParam, result);
      product[parserValue.key] = parserValue.value;
      return true;
    });

    return product;
  }

  /**
   * get product owner
   * @param {*} id id of product
   */
  async getProductOwner(id) {
    return await this.contract.methods.productOwner(id).call();
  }

  /**
   * get product owner
   * @param {*} id id of product
   */
  async getProductDefaultQuantity(id) {
    return await this.contract.methods.quantity(id).call();
  }

  /**
   * update product new category
   * @param {*} id id of product
   * @param {*} newCategory new category update
   */
  async updateProductNewCat(id, newCategory) {
    return await this.contract.methods.updateProductNewCat(id, newCategory).send();
  }

  /**
   * check product exist
   * @param {*} id id of product
   */
  async checkExist(id) {
    return await this.contract.methods.checkExists(id).call();
  }

  /**
   * set un-publish for product status
   * @param {*} id id of product
   */
  async setUnPublishProduct(id) {
    const checkPublishStatus = await this.contract.methods.isProductAvailAndPublished(id).call();
    if (!checkPublishStatus) {
      throw new Error('Already unpublished');
    }

    const result = await this.contract.methods.unpublishProduct(id).send();

    const eventOutputAbi = await getEventOutputAbi('ProductUpdatedPublishStatus', abi);

    const setUnpublicEvent = {};
    if (result && result.events && result.events.ProductUpdatedPublishStatus) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, result.events.ProductUpdatedPublishStatus.returnValues);
        setUnpublicEvent[parserValue.key] = parserValue.value;
        return true;
      });
    }

    return setUnpublicEvent;
  }

  /**
   * set publish for product status
   * @param {*} id id of product
   */
  async setPublishProduct(id) {
    const checkPublishStatus = await this.contract.methods.isProductAvailAndPublished(id).call();
    if (checkPublishStatus) {
      throw new Error('Already published');
    }

    // return await this.contract.methods.publishProduct(id).send();
    const result = await this.contract.methods.publishProduct(id).send();
    const eventOutputAbi = await getEventOutputAbi('ProductUpdatedPublishStatus', abi);

    const setUnpublicEvent = {};
    if (result && result.events && result.events.ProductUpdatedPublishStatus) {
      await eventOutputAbi.map(eachParam => {
        const parserValue = paramParser(eachParam, result.events.ProductUpdatedPublishStatus.returnValues);
        setUnpublicEvent[parserValue.key] = parserValue.value;
        return true;
      });
    }

    return setUnpublicEvent;
  }

  /**
   * check product if avaiable and publish
   * @param {*} id id of product
   */
  async isProductAvailAndPublished(id) {
    return await this.contract.methods.isProductAvailAndPublished(id).call();
  }

  /**
   *
   * @param {*} id
   * @param {*} owner
   */
  async checkShopOwner(id, owner) {
    return await this.contract.methods.checkShopOwner(id, owner).call();
  }

  async getNrProductsInCat(id) {
    let result = await this.contract.methods.getNrProductsInCat(id).call();
    result = parseInt(result);
    return result;
  }

  /**
   * get length of product's array
   */
  async getLengthProducts() {
    let result = await this.contract.methods.getLengthProducts().call();
    result = parseInt(result);
    return result;
  }
}
export default Products;
